import * as React from "react";

/**
 * CTA primitives shared across the test-landing experiment bodies: the
 * one-shape `useStartDiagnostic()` contract (so every arm keeps identical
 * in-place gate mechanics and a single busy state) and the arrow glyph the
 * primary button wears. Extracted here when the old full-page control arm
 * (`ControlBody`) was retired — these two were its only surviving exports.
 */
export interface DiagnosticCta {
  start: () => Promise<void>;
  busy: boolean;
}

export function ArrowIcon({ size = 16 }: { size?: number }): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}
